import { app } from '@microsoft/teams-js';

export function isRunningInTeams(): Promise<boolean> {
    return new Promise((resolve) => {
        app.initialize()
            .then(() => {
                resolve(true);
            })
            .catch(() => {
                resolve(false);
            });
    });
}